import { Map } from 'immutable'
import * as React from 'react'
import {
  Action,
  any,
  async,
  AsyncState,
  IOWidget,
  loadedAsyncState,
  loadingAsyncState,
  mk_widget,
  Pair,
  stateful
} from 'widgets-for-react'
import { CaseResponse } from '../../../../../wp_types'
import { getClassName, link, linkWrapper } from '../../../../cms/blocks/utils.gen'
import { TemplateState } from '../../../../cms/page/types.gen'
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.gen'
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { DataLayer } from '../../../utils/datalayer'
import { CustomBlockData } from '../types.mod'
import i18next from 'i18next'
import { ImageContainer } from '../../../../cms/blocks/widgets/ImageContainer.gen'
import { ImageSize } from '../../../../cms/blocks/types.gen'
import { beslismatrixWizardWidget } from '../../../custom_pages/beslismatrixPage/beslismatrixWizardWidget'
import { FormState } from '../../../../form/types'
import { BeslismatrixFormState } from '../../../custom_pages/beslismatrixPage/beslismatrixWizardState'
import { Entity } from 'ts-lenses'
import { markdown } from '../../../utils/markdown'

export type BSLBeslismatrixFormBlockProps = {
  key?: string
  beslismatrixFormState: BeslismatrixFormState
}

export type BSLBeslismatrixFormBlockState = {}

export type BSLBeslismatrixFormBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  content_classname: string
}>

export function BSLBeslismatrixFormBlock<customBlockData, extra_images>(
  props: BSLBeslismatrixFormBlockProps,
  options?: { style?: BSLBeslismatrixFormBlockStyle; key?: string }
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>>
> {
  return (s: TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: setState => {
        function SetBlockProps(newValue: BeslismatrixFormState) {
          return (
            s1: TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>
          ): TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData> => {
            let key = s.blocks.findKey(b => b.kind == 'beslismatrix_form')
            let current_block = s.blocks.get(key)

            if (current_block.kind != 'beslismatrix_form') return s1
            current_block = Entity(current_block).set("value", val =>
              Entity(val).set("fst", fst =>
                Entity(fst).set("beslismatrixFormState", () => {
                  return newValue
                }).commit()
              ).commit()
            ).commit()

            return Entity(s1).set("blocks", () => {
              return s1.blocks.set(key, current_block)
            }).commit()
          }
        }

        return (
          <section
            className={getClassName(options, 'block_classname', 'block')}
            key={options && options.key ? options.key : ''}
          >
            <div className={getClassName(options, 'inner_classname', '')}>
              <div className={getClassName(options, 'header_classname', '')}>
                <div className="text--styled">

                  {props.beslismatrixFormState.IntroText && props.beslismatrixFormState.IntroText != "" ?
                    <p dangerouslySetInnerHTML={{ __html: markdown(i18next.t(props.beslismatrixFormState.IntroText)) }} />
                    : <p>{i18next.t('Beslismatrix.Intro_Text')}</p>}

                </div>
              </div>


              <div className={getClassName(options, 'content_classname', '')}>
                {beslismatrixWizardWidget(props.beslismatrixFormState).run(u =>
                  setState(SetBlockProps(u(props.beslismatrixFormState)))
                )}
              </div>
            </div>
          </section>
        )
      }
    })
}
